import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { excursionOptionPropTypes } from './PropTypes';

import {
  currencyDepositAndTotalPricePropTypes,
  getCurrencyPriceFromCurrencyOptions,
} from '../../../util/currency';
import UpgradeCard from '../BookingFieldset/UpgradeCard';

const propTypes = exact({
  currencyPriceSetting: currencyDepositAndTotalPricePropTypes,
  currencySymbol: PropTypes.string.isRequired,
  dateText: PropTypes.string,
  groupKey: PropTypes.string.isRequired,
  handleFieldSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(excursionOptionPropTypes).isRequired,
  perPersonText: PropTypes.string,
  selectedKey: PropTypes.string,
  selectedText: PropTypes.string,
  timeText: PropTypes.string,
});

const defaultProps = {
  selectedKey: null,
  selectedText: '',
  perPersonText: 'pp',
};
function Excursions(props) {
  const {
    groupKey,
    handleFieldSelect,
    selectedText,
    selectedKey,
    options,
    currencyPriceSetting,
    currencySymbol,
    perPersonText,
  } = props;

  return (
    <div className="UpgradeGroup">
      <div className="UpgradeGroup_itemGroup">
        {options.map((excursionOption) => {
          const currencyPriceSettingPrice = getCurrencyPriceFromCurrencyOptions(
            excursionOption.pricePerPax[0].pricePerCurrency,
            currencyPriceSetting.currency
          );
          return (
            <div
              className="UpgradeGroup_item UpgradeGroup_item-fullWidth"
              key={excursionOption.key}
            >
              <UpgradeCard
                currencySymbol={currencySymbol}
                date={excursionOption.date}
                dateText={props.dateText}
                blockName="UpgradeGroup_card"
                description={excursionOption.fullDescription}
                handleClick={() => handleFieldSelect(groupKey, excursionOption.key)}
                images={[excursionOption.image]}
                isSelected={excursionOption.key === selectedKey}
                limitedAvailability={excursionOption.limitedAvailability}
                limitedAvailabilityRemainingSpaces={
                  excursionOption.limitedAvailabilityRemainingSpaces
                }
                limitedAvailabilityRemainingText={excursionOption.limitedAvailabilityText}
                limitedAvailabilityText={excursionOption.limitedAvailabilityText}
                price={currencyPriceSettingPrice}
                pricePerPerson
                perPersonText={perPersonText}
                selectedText={selectedText}
                title={excursionOption.title}
                time={excursionOption.time}
                timeText={props.timeText}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

Excursions.propTypes = propTypes;
Excursions.defaultProps = defaultProps;

export default Excursions;
